import { render, staticRenderFns } from "./EditAdmins.vue?vue&type=template&id=5039422a&scoped=true"
import script from "./EditAdmins.vue?vue&type=script&lang=js"
export * from "./EditAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5039422a",
  null
  
)

export default component.exports